import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  module: {
    display: "contents",
    cursor: "pointer",
    "& .MuiList-root": {
      display: "flex",
      alignItems: "center",
      marginLeft: "35px",
    },
  },
  textCompleted: {
    "& .moduleName, & .moduleSubname": {
      color: "#747F9D",
    },
  },
  textInProgress: {
    "& .moduleName, & .moduleSubname": {
      color: "#000000",
    },
  },
  textNew: {
    "& .moduleName, & .moduleSubname": {
      color: "#A2A9BD",
    },
  },
  gamePlanOptionBody: {
    display: "flex",
    alignItems: "center",
    "& svg": {
      marginRight: "12px",
    },
  },
  firstLevel: {
    padding: "16px 0px 16px 20px",
  },
  secondLevel: {
    padding: "0px 0px 16px 0px",
  },
  checked: {
    "& path": {
      fill: "#00A3A3",
    },
  },
  isInProgress: {
    color: "#000000",
    "& path": {
      fill: "white",
    },
    "& circle": {
      fill: "#F15A28",
    },
  },
  moduleName: {
    fontFamily: "Lato",
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(14),
  },
  moduleSubname: {
    fontFamily: "Lato",
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(16),
  },
  isFocused: {
    fontWeight: 700,
  },
  lesson: {
    width: "fit-content",
    paddingLeft: "35px",
    "& span": {
      fontFamily: "Lato",
      fontWeight: 400,
      fontSize: theme.typography.pxToRem(16),
    },
    "& svg": {
      marginRight: "24px",
    },
    "& .inProgress": {
      color: "#000000",
    },
    "& .completed": {
      color: "#747F9D",
    },
    "& .new": {
      color: "#A2A9BD",
    },
    cursor: "pointer",
  },
}));
